import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const WHATSAPP_NUMBER = '5511920897014';
export const WHATSAPP_GROUP = 'https://chat.whatsapp.com/KwHinFwPNlaB8UjEvhZPeW';
export const LINKEDIN_HIGOR = 'https://www.linkedin.com/in/higormonteiroh/';

export const WA_URL = (msg) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg || 'Olá! Gostaria de saber mais sobre os serviços da HM Talent.')}`;

export const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatBRL = (v) => {
  const n = Number(v);
  if (v === '' || v === null || v === undefined || Number.isNaN(n)) return '';
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
